import ServicesList from '../components/Services/ServicesList';

const Services = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding bg-gradient-to-r from-primary-600 to-primary-800 text-white">
        <div className="container-custom text-center">
          <h1 className="text-5xl font-bold mb-6">Our Services</h1>
          <p className="text-xl text-primary-100 max-w-3xl mx-auto">
            Comprehensive technology solutions designed to accelerate your business growth 
            and enhance operational efficiency.
          </p>
        </div>
      </section>

      <ServicesList />

      {/* Process Section */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <h2 className="text-4xl font-bold text-center mb-12">Our Process</h2>
          <div className="grid md:grid-cols-4 gap-8">
            {[
              { step: "01", title: "Discovery", desc: "Understanding your needs" },
              { step: "02", title: "Planning", desc: "Designing the solution" },
              { step: "03", title: "Implementation", desc: "Deploying technology" },
              { step: "04", title: "Support", desc: "Ongoing optimization" },
            ].map((process) => (
              <div key={process.step} className="text-center">
                <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-2xl font-bold text-primary-700">{process.step}</span>
                </div>
                <h3 className="text-xl font-bold mb-2">{process.title}</h3>
                <p className="text-gray-600">{process.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;